module.exports = __webpack_public_path__ + "img/15.44df62f9.png";